import PigGroupTreatmentsPanel from './PigGroupTreatmentsPanel';

export default PigGroupTreatmentsPanel;
